if (!customElements.get('testimonials-slider')) {
    customElements.define('testimonials-slider', class TestimonialsSlider extends HTMLElement {
        constructor() {
            super();

            this.slides = this.querySelectorAll('.glide__slide');
            this.glide = this.querySelector('.glide');
            this.glideInstance = null;
            this.initSlider();
        }

        initSlider() {
            if (this.slides.length > 1)
                this.glideInstance = new Glide(this.glide, {
                    type: 'carousel',
                    startAt: 0,
                    focusAt: 'center',
                    swipeThreshold: false,
                    dragThreshold: false,
                    perView: 4,
                    perTouch: 1,
                    gap: 20,
                    breakpoints: {
                        749: {
                            perView: 1
                        }
                    },
                    rewind: true,
                }).mount();
        };
    });
}

if (!customElements.get('testimonials-text-slide')) {
    customElements.define('testimonials-text-slide', class TestimonialsSlider extends HTMLElement {
        constructor() {
            super();

            this.slides = this.querySelectorAll('.glide__slide');
            this.glide = this.querySelector('.glide');
            this.glideInstance = null;
            this.initSlider();
        }

        initSlider() {
            if (this.slides.length > 1)
                this.glideInstance = new Glide(this.glide, {
                    type: 'carousel',
                    startAt: 0,
                    perView: 3,
                    focusAt: 'center',
                    swipeThreshold: false,
                    dragThreshold: false,
                    perTouch: 1,
                    gap: 20,
                    breakpoints: {
                        749: {
                            perView: 1
                        }
                    },
                    rewind: true,
                }).mount();
        };
    });
}

$('.glide-arrow-testimonals .glide__arrow--left').click(function () {
    $('.glide-arrow-test-down .glide__arrow--left').click();
})
$('.glide-arrow-testimonals .glide__arrow--right').click(function () {
    $('.glide-arrow-test-down .glide__arrow--right').click();
})
